import { UserInfo } from '../services/user/user.service'

/** KPI ダッシュボードの管理権限を持つかどうかを判定する。 */
export const hasManagementRole = (user: UserInfo): boolean =>
  user.roles.some(
    (role) => role.code === 'SUPER_ADMIN' || role.code === 'ENABLER',
  )
